import {getJson, Response} from "./request.ts";

export enum CallMeState {
    InboundOpen,
    OutboundOpen,
    InboundAndOutboundClosed
}

export type CallMeQueue = undefined | null | "exit-rmo" | "mesh-rmo"

interface ContactDetails {
    inbound: boolean,
    outbound: boolean,
}

interface ContactDetailsResponse extends Response {
    response: ContactDetails
}

const calculateCallMeState = (details: ContactDetails) => {
    if (details.inbound) {
        return CallMeState.InboundOpen
    }

    if (details.outbound) {
        return CallMeState.OutboundOpen
    }

    return CallMeState.InboundAndOutboundClosed
}

export const getCallMeOpeningHours = async () => {
    const details: ContactDetailsResponse = await getJson(`/call-me/opening-hours`)

    return calculateCallMeState(details.response)
}
